<template>
    <div>
        <div
            v-if="!data.WidgetLayout?.ComponentTypeID"
            class="w-full main-bg-dark p-6 -my-4 text-center rounded main-text-color"
        >
            {{ $t('widget.selectAWidgetType') }}
        </div>
        <component
            :is="componentType"
            v-else-if="componentType"
            :data="data"
            v-bind="data.WidgetLayout"
            :editable="editable"
            class="widget"
            @on-update="updateWidget"
        />
    </div>
</template>
<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue'
import RedesignFunnel3DChart from '@/components/RedesignComponents/Charts/RedesignFunnel3DChart.vue'
import CounterCard from '@/components/Cards/CounterCard.vue'
import GaugeChart from '@/components/Charts/FunnelChart/GradeGaugeChart.vue'
import RedesignTimeLineChart from '@/components/RedesignComponents/Charts/RedesignTimeLineChart.vue'
import RedesignPieChart from '@/components/RedesignComponents/Charts/RedesignPieChart.vue'
import SocketsRealTimeFunnel from '@/components/Charts/FunnelChart/FunnelChart.vue'
import widgetComponentTypes from '@/enum/widgetComponentTypes'
import { WidgetExtended } from '@/types/dashboard'
import TableData from '@/components/RedesignBaseComponents/RedesignTableData.vue'

const emit = defineEmits<{
    (event: 'on-update', widgetData: WidgetExtended): void
}>()

const props = withDefaults(
    defineProps<{
        data: WidgetExtended
        editable: boolean
    }>(),
    {
        editable: false
    }
)

const components = {
    RedesignFunnel3DChart,
    CounterCard,
    GaugeChart,
    TableData,
    RedesignTimeLineChart,
    RedesignPieChart,
    SocketsRealTimeFunnel
}

const componentType = computed(() => {
    if (!props.data.WidgetLayout?.ComponentTypeID) return null
    const componentName = widgetComponentTypes[props.data.WidgetLayout.ComponentTypeID]

    if (componentName && componentName in components) {
        return components[componentName as keyof typeof components]
    }

    return null
})

const updateWidget = (widgetData: WidgetExtended) => {
    emit('on-update', widgetData)
}
</script>
